export default {
  paymentConditionTables: [],
  paymentMethods: [],
  contactMethods: [],
  selectedPaymentConditionTable: {}
}
